export default {
  global: {
    brandName: 'Drive',
    brandWebsiteUrl: 'drive.no',
    currencyUnit: 'kr',
    modalTitle: 'Utfor verdivurdering på bilen din i samarbeid med {{brandName}}',
  },
  other: {
    loading: 'Laster...',
    closeModal: 'Lukk modalen',
  },
  glossary: {
    change: 'Endre',
    next: 'Neste',
    modelYear: 'Modellår',
    manufactureYear: 'Produksjonsår',
    gearbox: 'Girkasse',
    color: 'Farge',
    fuelType: 'Drivstoff type',
    chassis: 'Kaross',
    segment: 'Segment',
    drivingWheel: 'Drivhjul',
    mileage: 'Kilometerstand',
    mileageUnit_one: 'km',
    mileageUnit_other: 'km',
    condition: 'Tilstand',
  },
  error: {
    unspecific: 'Det har oppstått en error. Prøv igjen.',
    valuation:
      'Dessverre fant vi ikke treff på registreringsnummeret du skrev inn. Kontroller at registreringsnummeret er riktig.',
    vehicle:
      'Beklager, det ser ut til at vi ikke kan hente noen data om denne bilen og kan ikke gi deg en verdivurdering, for eksempel kan det være fordi bilen er importert. Dobbeltsjekk også at du har oppgitt riktig registreringsnummer.',
  },
  footer: {
    poweredByBrand: 'Powered by{{link}}',
    poweredByBrandLinkTitle: 'Gå til {{nettsted}}',
    poweredByBrandLinkUrl: 'https://www.drive.no',
  },
  input: {
    registrationNumber: {
      label: 'Registreringsnummer',
      placeholder: 'Skriv inn registreringsnummer',
      error: 'Et gyldig registreringsnummer i formatet AB12345 må angis',
    },
    mileage: {
      label: 'Kilometerstand',
      placeholder: 'Skriv inn bilens kjørelengde',
      error: 'Et gyldig kjørelengdenummer må angis',
    },
    firstName: {
      label: 'Fornavn',
      placeholder: 'Skriv inn fornavn',
      error: 'Du må skrive inn fornavnet ditt',
    },
    lastName: {
      label: 'Etternavn',
      placeholder: 'Skriv inn etternavn',
      error: 'Du må skrive inn etternavnet ditt',
    },
    email: {
      label: 'E-postadresse',
      placeholder: 'Skriv inn e-postadresse',
      error: 'Du må skrive inn e-postadressen din',
    },
    phone: {
      label: 'Telefonnummer (valgfritt)',
      placeholder: 'Skriv inn telefonnummer',
      error: 'Du må skrive inn telefonnummeret ditt',
    },
    branch: {
      label: 'Plant',
      placeholder: 'Velg anlegg',
      help: 'Vi har flere anlegg i Sverige. Velg anlegget du vil kontakte.',
    },
    description: {
      label: 'Godt å vite om bilen min (valgfritt)',
      placeholder:
        'Er det noe mer om bilen din du vil fortelle oss? Noe som kan påvirke verdien som servicehistorikk, ekstrautstyr, vinterdekk?',
      error: 'Du må legge til en beskrivelse',
    },
  },
  init: {
    title: 'Gratis verdivurdering av bilen din',
    expandedTitle: 'Vurder bilen gratis uten å forplikte deg til noe',
    startButtonText: 'Start verdivurdering',
    expandButtonText: 'Utvid {{brandName}}s vurderingsmodul',
    minifyButtonText: 'Minify {{brandName}} sin vurderingsmodul',
    association: {
      body: 'Evaluering i samarbeid med {{link}}',
      linkTitle: 'Gå til {{website}}',
      linkUrl: 'https://www.drive.no',
    },
  },
  summary: {
    thankYouMessage: 'Takk {{name}} for interessen!',
    whatHappensNow: {
      heading: 'Hva skjer nå?',
      body: [
        'Vi vil gjennomgå detaljene til bilen din og kontakte deg, vanligvis innen 24 timer. Etter det går vi gjennom alle detaljene sammen, og hvis du velger å fortsette med salget, hjelper vi deg med alt papirarbeidet.',
        'Hvis du er interessert i å kjøpe en ny bil, kan vi hjelpe deg med det også.',
      ],
    },
    closeButtonText: 'Lukk',
  },
  confirmClose: {
    heading: 'Fullfør verdivurderingen',
    body: 'Er du sikker på at du vil avslutte evalueringen?',
    buttonContinueText: 'Fortsett med min vurdering',
    buttonCancelText: 'Avbryt min vurdering',
  },
  vehicleDetails: {
    label: 'Bulip oppgaver',
  },
  mileageAndCondition: {
    label: 'Bilens kjørelengde og tilstand',
    heading: 'Oppgi bilens kjørelengde og tilstand',
    conditionRadioGroup: {
      label: 'Biltilstand',
      error: 'Må velge bilens tilstand',
      help: 'Velg det alternativet som passer best til bilens tilstand. Hvis du ønsker å selge bilen, vil du i neste steg også kunne skrive inn selv om det er noe du mener vi trenger å vite om bilen din.',
    },
    seeEstimatedPurchasePrice: 'Se estimert kjøpspris',
    condition: {
      veryGood: {
        label: 'Meget god stand',
        requirements: [
          'Ingen riper eller skader',
          'Komplett servicehefte med stempel fra merkeforhandler',
          'Dekk med veldig god mønsterdybde (5-8 mm)',
        ],
      },
      good: {
        label: 'God stand',
        requirements: [
          'Noen mindre riper og/eller skader',
          'Komplett servicehefte med stempel fra merkeforhandler',
          'Dekk som ikke trenger å skiftes (mønsterdybde 3-5 mm)',
        ],
      },
      ok: {
        label: 'Perfekt stand',
        requirements: [
          'Det er noen riper og skader',
          'Ikke betjent ved enhver anledning',
          'Dekk må skiftes (mønsterdybde under 3 mm)',
        ],
      },
    },
  },
  valuation: {
    label: 'Verdivurdering',
    estimatedPurchasePrice: {
      heading: 'Estimert kjøpspris',
      body: 'Et område mellom {{low}} og {{high}}.',
    },
    calculation: {
      heading: 'Hvordan beregnet vi dette?',
      body: [
        'Kjøpsprisen er basert på lignende biler på markedet som for øyeblikket er til salgs eller nylig har vært til salgs.',
        'Vi inkluderer mange parametere om bilen din for å gi en mest mulig nøyaktig pris, der tjenesten vår hele tiden utvikles og forbedres.',
        'Kjøpsprisen du får her er en indikasjon på bilens verdi, men sluttprisen kan gå opp og ned avhengig av bilens tilstand og andre faktorer vi ikke kunne ta hensyn til i denne verdivurderingen. For å kunne gi en endelig kjøpesum, må vi se bilen din og dens servicehistorikk.',
        'Hvis det er for lite informasjon på markedet om akkurat din bil, kan det være vanskelig å gi en innkjøpspris. Ta gjerne kontakt med oss så ser vi nærmere på bilen din pả verkstedet i stedet.',
      ],
    },
    factors: {
      label: 'Faktorer som kan påvirke salgsprisen',
      positive: {
        heading: 'Faktorer som kan påvirke salgsprisen positivt kan være:',
        usps: [
          'Hvis bilen din har noe verdiøkende utstyr som vi ikke kan se ennå, for eksempel et ettermontert hengerfeste eller nye felger.',
          'Hvis bilen din er i veldig god stand og du har tatt ekstra godt vare på den.',
          'Hvis det for tiden er stor etterspørsel etter modellen din.',
        ],
      },
      negative: {
        heading: 'Faktorer som kan påvirke salgsprisen negativt kan være:',
        usps: [
          'Hvis det er skader eller mangler som krever at vi reparerer før videresalg.',
          'Hvis det er noe i bilens historikk som ikke vises før vi har sjekket bilen, for eksempel hvis det mangler servicestempler.',
          'Hvis det er mange lignende biler til salgs akkurat nå.',
        ],
      },
    },
  },
  about: {
    label: 'Informasjon om hvordan verdsettelsen fungerer',
    heading: 'Verdivurder bilen gratis',
    body: [
      'Skriv inn bilens kjorelengde og tilstand sá vil du motta en estimert kjopesum for bilen din, helt kostnadsfritt.',
      'Om du ogsà onsker ả selge bilen, kan du fylle inn kontaktinformasjon, sả vil vi kontake deg.',
    ],
    checklist: [
      'Vurderingen er helt gratis',
      'Du bestemmer selv om du vil selge bilen - og forplikter deg ikke til noe',
    ],
  },
  contact: {
    label: 'Renteerklæring salg av bil',
    heading: 'Vil du selge bilen?',
    body: 'Selg oss bilen din! Fyll inn interessemeldingen så kontakter vi deg. Du forplikter deg ikke til noe ved å registrere interesse.',
    detailsHeading: 'Kontaktdetaljer',
    carInformationHeading: 'Vil du gi mer informasjon om bilen din?',
    nextStep: {
      heading: 'Hva er neste steg?',
      body: 'Vi vil kontakte deg for å bli enige om ut detaljene for salget sammen. Husk at du ikke forplikter deg til noe.',
    },
    requestError: 'Det var ikke mulig å sende interessemeldingen. Prøv igjen.',
    disclaimer: {
      body: 'Registreringsnummeret ditt og personlige data behandles av vår verdivurderingsleverandør {{brandName}} og vil bli delt med {{branch}}. {{link}}',
      link: {
        title: 'Les mer om hvordan ditt registreringsnummer og personopplysninger behandles',
        text: 'Les mer',
        url: 'https://www.drive.no',
      },
    },
    sendFormButtonText: 'Send inn interessemelding',
  },
};
